import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Trans, { transString } from './helpers/Trans';

class Search extends Component {
    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.getCurrentPosition = this.getCurrentPosition.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.input.value) {
            return;
        }
        this.props.search(`Switzerland ${this.input.value}`);
    }

    getCurrentPosition(event) {
        event.preventDefault();
        // Try W3C Geolocation (Preferred)
        if (navigator.geolocation) {
            this.props.setLoading(true);
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const location = new window.google.maps.LatLng(
                        position.coords.latitude,
                        position.coords.longitude,
                    );
                    this.props.locate(location);
                },
                () => {
                    // error callback
                    this.props.setLoading(false);
                },
            );
        }
    }

    render() {
        return (
            <div className="location-finder-filter">
                <div className="location-finder-filter__search-container">
                    <form onSubmit={this.handleSubmit}>
                        <input
                            type="search"
                            ref={(input) => {
                                this.input = input;
                            }}
                            name="locations-search"
                            className="form-control location-finder-filter__search-input"
                            placeholder="Nach Standort oder PLZ"
                        />
                    </form>
                    <button
                        className="location-finder-filter__search-btn"
                        onClick={this.handleSubmit}
                    >
                        <span className="sr-only">
                            Suchen
                        </span>
                    </button>
                </div>
                <div className="location-finder-filter__nearby-container">
                    <button
                        name="locations-nearby"
                        className="location-finder-filter__nearby-link"
                        onClick={this.getCurrentPosition}
                        style={{
                            opacity: navigator.geolocation ? 1 : 0.5,
                        }}
                    >
                        In meiner Nähe
                    </button>
                </div>
            </div>
        );
    }
}

Search.propTypes = {
    locate: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
};

export default Search;



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/Search.js